import { EventBus } from '../../services/event-bus.js';
import { MUTATIONS } from '../constants';
import { EVENTS } from '../nameConstants';
import { yoyoHttp } from '../../services/http.service';
import store from '..';
import Vue from 'vue';

const mutations = {
    [MUTATIONS.CREATESHIPMENT.SET_ADDRESS_BOOK](state, data) {
        state.createShipment.addressBook = data;
    },

    [MUTATIONS.CREATESHIPMENT.SET_PROTOTYPE_SHIPMENT](state, data) {
        state.shipment = data;
        state.prototype = data;
        EventBus.$emit(EVENTS.SHIPMENT_PROTOTYPE_LOADED, data);
    },

    [MUTATIONS.CREATESHIPMENT.SET_SELECTED_COMPANYID](state, data) {
        state.selectedCompanyId = data;
    },

    [MUTATIONS.CREATESHIPMENT.SET_INITIALIZED](state) {
        state.initialized = true;
    },

    [MUTATIONS.CREATESHIPMENT.SET_COMPANY_ACCOUNT_ADDRESSES](state, data) {
        state.companyAccountAddresses = data;
        const sender = state.companyAccountAddresses.find((obj) => {
            return obj.accountTypeId === 3;
        });
        const pickup = state.companyAccountAddresses.find((obj) => {
            return obj.accountTypeId === 1;
        });

        if (!sender) {
            console.error('Sender Address not found');
        }

        if (!pickup) {
            console.error('Pickup Address not found');
        }
        EventBus.$emit(EVENTS.SET_SENDER, sender);
        EventBus.$emit(EVENTS.SET_PICKUP, pickup);
    },

    [MUTATIONS.CREATESHIPMENT.SET_ADDRESS_BOOK](state, data) {
        let i = 0;
        data.forEach((element) => {
            element.key = i;
            i++;
        });

        state.addressBook = data;
    },

    [MUTATIONS.CREATESHIPMENT.SET_SHIPMENT](state, data) {
        state.shipment = data;
        EventBus.$emit(EVENTS.SHIPMENT_SET);
    },
    [MUTATIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS](state) {
        state.shippingOptions = {};
        state.servicePrices = [];
    },
    showPickup(state, showPickup) {
        state.showPickup = showPickup;
    },
    [MUTATIONS.CREATESHIPMENT.SET_BOOKING_OPTIONS](state, data) {
        state.bookingOptions = data;
        if (state.bookingOptions.viewOptions) {
            const element = state.bookingOptions.viewOptions.find((obj) => {
                return obj.name === 'PackageDimensions';
            });
            if (element) {
                state.isColliDimension = element.display;
            }
        }
    },
    [MUTATIONS.CREATESHIPMENT.SET_SERVICE_PRICES](state, data) {
        state.servicePrices.push(data);

        state.shippingOptions.products.forEach((product) => {

            if (product.productServiceGroups) {
                product.productServiceGroups.forEach((group) => {

                    group.availableProductServices.forEach((service) => {

                        if (service.serviceId === data.serviceId && product.salesProductId === data.salesProductId) {
                            service.price = data.priceLines.value;
                        }
                    });
                });
            }
        });
    },

    [MUTATIONS.CREATESHIPMENT.SET_DEFAULT_VALUES](state, data) {
        state.defaultValues = data;
    },
    [MUTATIONS.CREATESHIPMENT.SET_DANGEROUS_GOODS_TYPES](state, data) {
        state.dangerousGoodsTypes = data;
    },
    [MUTATIONS.CREATESHIPMENT.SET_DANGEROUS_GOODS_DESCRIPTIONS](state, data) {
        state.dangerousGoodsDescriptions = data;
    },

    [MUTATIONS.CREATESHIPMENT.SET_PACKAGING_TYPES](state, data) {
        state.packagingTypes = data;
    },
    [MUTATIONS.CREATESHIPMENT.SELECT_SHIPPING_OPTION_PRODUCT](state, payload) {
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < state.shippingOptions.products.length; i++) {
            const el = state.shippingOptions.products[i];

            if (
                el.salesProductId === payload.salesProductId &&
                !el.selected &&
                el.transportProductId === payload.transportProductId
            ) {
                el.selected = true;
            } else {
                el.selected = false;
            }
        }
    },

    [MUTATIONS.CREATESHIPMENT.SET_PRICE_EXPANDED](state, data) {
        state.shippingOptions.products[data.index].priceExpanded = data.priceExpanded;
    },

    [MUTATIONS.CREATESHIPMENT.CLEAR_SELECT_SHIPPING_OPTION_PRODUCT](state) {
        state.shippingOptions.products.forEach((element) => {
            element.selected = false;
        });
    },
    [MUTATIONS.CREATESHIPMENT.SET_SHIPPING_OPTIONS](state, data) {
        data.products.forEach((product) => {
            product.prebooking = false;
        });

        data.products.forEach((product) => {
            product.quoteBooking = false;
        });

        data.quoteProducts.forEach((product) => {
            product.quoteBooking = true;
        });

        state.shippingOptions = data;

        state.shippingOptions.products.forEach((product) => {
            product.priceExpanded = false;
        });



        state.backendErrors = data.errors;
    },

    [MUTATIONS.CREATESHIPMENT.SET_TRANSITTIMES](state, transitTimes) {

        state.shippingOptions.products.forEach(product => {
            if (!product || !transitTimes) {
                return;
            }
            let transitTime = transitTimes.find(el => el.product === product.transportProduct);
            if (!transitTime) {
                return;
            }
            product.estimatedTransitTime = transitTime.estimatedDeliveryDate;
            if (product.alternativeProducts) {
                product.alternativeProducts.forEach(altProduct => {
                    let altTransitTime = transitTimes.find(el => el.product === altProduct.transportProduct);
                    if (!altTransitTime) {
                        return;
                    }
                    altProduct.estimatedTransitTime = altTransitTime.estimatedDeliveryDate;
                });
            }
        });
        state.shippingOptions.quoteProducts.forEach(product => {
            if (!product || !transitTimes) {
                return;
            }
            let transitTime = transitTimes.find(el => el.product === product.transportProduct);
            if (!transitTime) {
                return;
            }
            product.estimatedTransitTime = transitTime.estimatedDeliveryDate;
        })


    },

    [MUTATIONS.CREATESHIPMENT.SET_BACKENDERROR](state, data) {
        state.backendErrors = [data];
    },

    [MUTATIONS.CREATESHIPMENT.SET_BACKENDERROR_TECHNICAL](state, data) {
        state.backendErrors = [data];
    },

    [MUTATIONS.CREATESHIPMENT.CLEAR_BACKENDERRORS](state) {
        state.backendErrors = [];
    },

    [MUTATIONS.CREATESHIPMENT.SHIPMENT_CREATED](state, data) {
        state.backendErrors = data.errors;
        if (data.success) {
            state.shippingOptions = {
                errors: [],
                products: [],
                success: false,
                transactionDetail: {}
            };
            state.labelUrl = data.labelUrl;
            state.trackingNumber = data.shipmentRef;
        }
    },

    [MUTATIONS.CREATESHIPMENT.SET_BACKENDERROR](state, error) {
        state.backendErrors = [error];
    },
    [MUTATIONS.CREATESHIPMENT.SET_ISCOLLIDEMENSIONS](state, data) {
        state.isColliDimension = data;
    },
    [MUTATIONS.CREATESHIPMENT.SET_ISDANGEROUSGOODS](state, data) {
        state.isDangerousGoods = data;
    },
    [MUTATIONS.CREATESHIPMENT.SET_INSURANCEAMOUNT_REQUIRED](state, data) {
        state.insuranceAmountRequired = data;
    },
    [MUTATIONS.CREATESHIPMENT.CHANGE_ISRECEIVERPAYS](state, data) {
        state.isReceiverPays = data;
    },
    [MUTATIONS.CREATESHIPMENT.SET_SHIPMENTPACKAGING](state, data) {
        state.shipmentPackaging = data;
    },
    [MUTATIONS.CREATESHIPMENT.SET_CUSTOMER_DESCRIPTIONS](state, data) {
        state.customerDescriptions = data;
    },
    [MUTATIONS.CREATESHIPMENT.SET_REFERENCE_TYPES](state, data) {
        state.referenceTypes = data;
    },

    [MUTATIONS.CREATESHIPMENT.UPSERT_SHIPMENTPACKAGING](state, data) {
        const index = state.shipmentPackaging.findIndex((obj) => {
            return obj.id === data.id;
        });

        if (index === -1) {
            state.shipmentPackaging.push(data);
        } else {
            state.shipmentPackaging[index] = data;
        }
    },
    [MUTATIONS.CREATESHIPMENT.DELETE_SHIPMENTPACKAGING](state, data) {
        const index = state.shipmentPackaging.findIndex((obj) => {
            return obj.id === data.id;
        });

        if (index !== -1) {
            Vue.delete(state.shipmentPackaging, index);
        }
    }
};

export default mutations;
